import {
    CategoryBarChart,
    ChartCard,
    type CategoryDatum,
} from '~/components/charts'

// 대분류별 달성률(%) 가로 막대 — 대분류 묶음별 획득 점수 대비 만점 비율.
export function CategoryAchievementChart({ data }: { data: CategoryDatum[] }) {
    return (
        <ChartCard
            title='대분류별 달성률'
            description='대분류 묶음별 획득 점수 대비 만점 비율'>
            <CategoryBarChart data={data} layout='vertical' unit='%' />
        </ChartCard>
    )
}
